"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagCC = function FlagCC(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.89,53.5a41.32,41.32,0,0,1,0-82.64,39.15,39.15,0,0,1,8.79,1A1,1,0,0,0,43.42-30a49.37,49.37,0,0,0-30.19-7.24A49.73,49.73,0,0,0-32.09,8.71,49.58,49.58,0,0,0,17.37,61.76a49.36,49.36,0,0,0,26.06-7.41,1,1,0,0,0-.74-1.87,39.31,39.31,0,0,1-8.8,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M69.9-22.8,73-14.95l8.08-2.47a.52.52,0,0,1,.6.76L77.48-9.34l7,4.77a.52.52,0,0,1-.22.94L75.88-2.35l.62,8.42a.52.52,0,0,1-.87.42L69.42.76l-6.2,5.73a.52.52,0,0,1-.87-.42L63-2.35,54.61-3.63a.52.52,0,0,1-.21-.94l7-4.77-4.21-7.32a.52.52,0,0,1,.6-.76l8.08,2.47,3.1-7.85a.51.51,0,0,1,1,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M182.89-44,186-36.13l8.08-2.48a.52.52,0,0,1,.6.76l-4.21,7.32,7,4.78a.52.52,0,0,1-.21.94l-8.35,1.27.61,8.43a.52.52,0,0,1-.87.42l-6.21-5.74-6.2,5.74a.52.52,0,0,1-.87-.42l.62-8.43-8.35-1.27a.52.52,0,0,1-.22-.94l7-4.78-4.21-7.32a.52.52,0,0,1,.6-.76l8.08,2.48L181.94-44a.51.51,0,0,1,.95,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M126.4-94.94l3.1,7.86,8.08-2.47a.51.51,0,0,1,.6.75L134-81.47l7,4.77a.52.52,0,0,1-.22.94l-8.35,1.28.61,8.42a.52.52,0,0,1-.87.42l-6.2-5.73-6.21,5.73a.51.51,0,0,1-.86-.42l.61-8.42-8.35-1.28a.52.52,0,0,1-.22-.94l7-4.77-4.21-7.33a.52.52,0,0,1,.6-.75l8.08,2.47,3.1-7.86a.52.52,0,0,1,1,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M126.4,90.19l3.1,7.86,8.08-2.48a.52.52,0,0,1,.6.76L134,103.65l7,4.78a.52.52,0,0,1-.22.94l-8.35,1.27.61,8.43a.52.52,0,0,1-.87.42l-6.2-5.74-6.21,5.74a.51.51,0,0,1-.86-.42l.61-8.43-8.35-1.27a.52.52,0,0,1-.22-.94l7-4.78-4.21-7.32a.52.52,0,0,1,.6-.76l8.08,2.48,3.1-7.86a.51.51,0,0,1,1,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M149.53-15.69l2.16,6.49,6.85.06a.55.55,0,0,1,.32,1l-5.5,4.07,2.06,6.53a.55.55,0,0,1-.85.61L149-.92l-5.57,4a.55.55,0,0,1-.84-.61l2.06-6.53-5.51-4.07a.55.55,0,0,1,.32-1l6.85-.06,2.17-6.49a.55.55,0,0,1,1.05,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-72.95-47.84a45.9,45.9,0,0,1-45.9,45.9,45.9,45.9,0,0,1-45.9-45.9,45.9,45.9,0,0,1,45.9-45.91,45.9,45.9,0,0,1,45.9,45.91Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-123.57-12.09h12.4s7-31.55.56-42.82l-4,2.54s6.49,21.69-9,40.28Zm0,0",
    transform: "translate(194 123)",
    fill: "#964b50"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-123.1-53.5s-7.14,4.88-4.88,19.34c0,0,5.44-4.5,8.45-14.46,0,0-4.32,8.26,1.69,14.84,0,0,6.38-9,5.44-16.9,0,0,21.24,22.17,16.72,16.52-.75-.93,1.13-10.33-6.2-18,0,0,12,3,16.53,1.88,0,0,.38-9.58-11.08-11.27l2.63-7.51s-8.83-.57-13.52,3.94c0,0-1.13-11.64,3.57-17.28,0,0-13.91-2.07-14.47,16.16,0,0-5.07-11.65-20.66-8.83,0,0,8.83,6.39,10.33,9.2,0,0-12.4-8.45-18.22,3.38,0,0,10-2.62,13.53,2.07,0,0-16-1.69-17.28,12,0,0,14.84-7,27.42-5.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagCC;
exports["default"] = _default;